import React from 'react';
import Modal from '../../modals/Modal'


const ViewBrand = props => {
    const { showViewBrandModal, brand, closeModal, setShowEditBrandModal, setShowViewBrandModal } = props

    const handleEdit = () => {
        setShowViewBrandModal(false)
        setShowEditBrandModal(true)
    }   
   
    return (
        <Modal
        id="view_brand"
        showModal={showViewBrandModal}
        closeModal={closeModal}
        modalHeader="Brand Details"
        buttonText="SAVE">
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    {/* <div className="table-head">
                        <h1 className="sec-header">View Brand Details</h1>
                    </div> */}
                    <div className="card ">
                        <div className="card-body box-row">
                            {/* <h1 className="section-header" style={{  textAlign: 'center' }}>Brand Details</h1> */}

                            {/* <div style={{ position: 'absolute', top: '0px', right: '15px' }}> */}
                                    {/* <Link to={`/edit-brands/${brand.brandId}`}> */}
                                        <button onClick={handleEdit} className="btn float-right submit-btn" variant="primary" type="submit"> Edit </button>
                                    {/* </Link> */}
                            {/* </div> */}

                            <div className="form-group row col-md-12">
                                <div className="col-md-3"><span><b>Brand name</b>{' '}:</span></div>
                                <div className="col-md-8"><span>{brand.brandName}</span></div>
                            </div>

                            <div className="form-group row col-md-12">
                                <div className="col-md-3"><span><b>Company name</b>{' '}:</span></div>
                                <div className="col-md-8"><span>{brand.brandCompanyName}</span></div>
                            </div>

                            <div className="form-group row col-md-12">
                                <div className="col-md-3"><span><b>Website name</b>{' '}:</span></div>
                                <div className="col-md-8"><span>{brand.brandWebsite}</span></div>
                            </div>

                            <div className="form-group row col-md-12">
                                <div className="col-md-3"><span><b>API Access</b>{' '}:</span></div>
                                <div className="col-md-8"><span>{ brand.brandApiAccess ? "Yes" : "No" }</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </Modal>

    );
}

export default ViewBrand;